import {get} from 'lodash'

type Props = {
  config: object
}

export const GZ911 = ({config}: Props) => {
  return <>{get(config, 'text', '')}</>
}
